/**
 * Storytelling Engine — the narrative arc of a flyer.
 *
 * Good promotional design tells a four-beat story: hook (stop the scroll),
 * promise (what you get), proof (why believe it), action (what to do now).
 * This engine maps content roles onto those beats — informed by the focal
 * decision, since the hook IS the focal point — and supplies tone words a
 * copywriter (later: OpenAI) should write in.
 */

export const ARC_BEATS = ['hook', 'promise', 'proof', 'action'];

const TONE_BY_MOOD = {
  premium: ['assured', 'understated', 'precise'],
  energetic: ['urgent', 'punchy', 'direct'],
  fresh: ['light', 'optimistic', 'crisp'],
  healthy: ['caring', 'trustworthy', 'clear'],
  warm: ['inviting', 'personal', 'generous'],
  elegant: ['refined', 'graceful', 'measured'],
  luxury: ['exclusive', 'quiet', 'confident'],
  playful: ['cheeky', 'bright', 'friendly'],
  bold: ['declarative', 'fearless', 'loud'],
  minimal: ['plain', 'exact', 'calm'],
};

/**
 * Build the narrative plan.
 * Returns { arc: { hook, promise, proof, action }, tone[], voiceNote }.
 */
export const planStory = ({ focus, mood, audience }) => {
  // The focal point opens the story; the CTA always closes it.
  const arc = {
    hook: focus.primary,
    promise: focus.primary === 'primaryHeading' ? 'secondaryHeading' : 'primaryHeading',
    proof: 'body',
    action: 'cta',
  };

  return {
    arc,
    tone: TONE_BY_MOOD[mood.id] || ['clear', 'direct'],
    voiceNote: `Write for a ${audience.name.toLowerCase()} audience: ${
      audience.readingHabit === 'image-first'
        ? 'copy supports the visual — short lines, no paragraphs doing the selling.'
        : audience.readingHabit === 'headline-first'
        ? 'the headline carries the pitch — make it a complete thought.'
        : 'this reader actually reads — body copy earns its space.'
    }`,
  };
};
